import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Hero() {
  const fullText = "Hi, I'm Parthibarajan R !";
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      setDisplayedText(fullText.slice(0, index + 1));
      index++;

      if (index === fullText.length) clearInterval(interval);
    }, 85); // typing speed

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="max-w-4xl mx-auto px-6 pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] items-center gap-8">

        {/* TEXT */}
        <div>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-black dark:text-white">
            {displayedText}
            <span className="animate-pulse">|</span>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.5 }}
            className="mt-4 text-lg text-black/60 dark:text-white/70"
          >
            CSE Student | Speaker | Learner
          </motion.p>
        </div>

        {/* IMAGE */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="flex justify-center"
        >
          <img
            src="/profile.jpg"   // ← keep your photo in public/profile.jpg
            alt="profile"
            className="w-36 h-36 md:w-44 md:h-44 object-cover rounded-2xl
            border border-black/10 dark:border-white/15 shadow-lg"
          />
        </motion.div>

      </div>
    </section>
  );
}
